import { apiList, apiGet, apiCreate, apiUpdate, apiDelete } from './apiClient';

export const getIntegrators = async (_params?: any) => apiList('integrators');
export const getIntegratorById = async (id: number | string) => apiGet('integrators', id);
export const createIntegrator = async (data: any) => apiCreate('integrators', data);
export const updateIntegrator = async (id: number | string, data: any) => apiUpdate('integrators', id, data);
export const deleteIntegrator = async (id: number | string) => apiDelete('integrators', id);
